import { useCallback } from "react";

import styled from "styled-components";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";
import FnrTypography from "UI/FnrTypography";

import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrTappyShrink from "UI/FnrTappyShrink";
import { marketingColors } from "UI/colors";

import { useCopyTextColor } from "../stateHooks";

import MainOptionButtonWrapper from "./MainOptionButtonWrapper";

const PrayerRequestButtonDisplay = () => {
  const textColor = useCopyTextColor();

  return (
    <Wrapper>
      <FnrContainedIcon
        color={marketingColors.red}
        icon="fa-praying-hands fad"
        size="xl"
      />
      <FnrTypography type="copy" color={textColor} bold>
        I have a prayer request
      </FnrTypography>
    </Wrapper>
  );
};

const Wrapper = styled(FnrTappyShrink)`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const PrayerRequestButton = () => {
  const { setActiveContentKey } = useMemberToolbarStore();
  const {
    flocknoteSupport,
    generalInquiry,
    prayerRequest,
    setFlocknoteSupport,
    setGeneralInquiry,
    setPrayerRequest,
  } = useMemberToobarContext();

  const showPrayerRequest = useCallback(() => {
    setActiveContentKey(contentKeys.form);
    setGeneralInquiry(false);
    setFlocknoteSupport(false);
    setPrayerRequest(true);
  }, [
    setActiveContentKey,
    setFlocknoteSupport,
    setGeneralInquiry,
    setPrayerRequest,
  ]);

  return (
    <MainOptionButtonWrapper
      data-cy="MemberToolbar_PrayerRequestButton"
      onClick={showPrayerRequest}
      autoFocus={!flocknoteSupport && !generalInquiry && prayerRequest}
      DisplayComponent={PrayerRequestButtonDisplay}
    />
  );
};

export default PrayerRequestButton;
